import { FC } from 'react';

import { StaticDateSpan } from '@myn/mui';

import { DateFieldProps } from '../types.js';
import TextVariant from './TextVariant.jsx';

type Props = Pick<DateFieldProps, 'scale' | 'value' | 'placeholder'>;

const DateVariant: FC<Props> = ({ scale, value, placeholder }) => {
  if (!value) {
    return <TextVariant scale={scale} value={null} placeholder={placeholder} />;
  }

  return <StaticDateSpan date={value} />;
};

export default DateVariant;
